module.exports = __webpack_public_path__ + "static/img/samsungdcb.dfc2f3f1.png";